<template>
  <keep-alive>
    <router-view></router-view>
  </keep-alive>
</template>

<script>
export default {
  name: "App",
  beforeCreate() {
    this.$store.dispatch('authentication/initialize');
  }
}
</script>